import { useDispatch } from 'react-redux';
import CardImage from '../../assets/target/images/Card-stub.png';
import { appSlice } from '../../store/slices';
import Icon, { Icons } from '../Icon/Icon';
import ListItem from '../ListItem';

import './CardTermsBlock.scss';

const CardTermsBlock = () => {
	const dispatch = useDispatch();

	const ITEMS = [
		{
			id: 'useCases',
			icon: Icons.CREDIT_CARD_FILL,
			title: 'Suitable use cases',
			description: 'Crypto corporate Cards are ideal for business-related expenses, including:',
			block: 'info',
		},
		{
			id: 'pricing',
			icon: Icons.DOLLARSIGN,
			title: 'Pricing Waivers',
			description: 'Learn when fees can be reduced or waived bas...',
			block: 'info',
		},
		{
			id: 'fees',
			icon: Icons.PERCENT,
			title: 'Card Fees',
			description: 'See detailed breakdown of all applicable car...',
			block: 'info',
		},
		{
			id: 'features',
			icon: Icons.BRIEFCASE_FILL,
			title: 'Features',
			description: 'Discover key card functionalities, security tools...',
			block: 'info',
		},
		{
			id: 'countries',
			icon: Icons.GLOBE,
			title: 'Supported countries',
			description: 'Available countries (up to 28.11.2025)',
			block: 'info',
		},

		{
			id: 'privacy',
			title: 'Privacy policy',
			block: 'terms',
		},
		{
			id: 'terms',
			title: 'Terms of use',
			block: 'terms',
		},
	];

	const itemDetails = {
		useCases: {
			icon: 'CREDIT_CARD',
			title: 'Suitable use cases',
			description: 'Learn about suitable use cases',
			type: 'modal',
		},
		pricing: {
			icon: 'DOLLARSIGN',
			title: 'Pricing Waivers',
			description: 'Learn about pricing waivers',
			type: 'modal',
		},
		fees: {
			icon: 'PERCENT',
			title: 'Card Fees',
			description: 'Learn about card fees',
			type: 'modal',
		},
		features: {
			icon: 'BRIEFCASE',
			title: 'Features',
			description: 'Learn about features',
			type: 'modal',
		},
		countries: {
			icon: 'GLOBE',
			title: 'Supported countries',
			description: 'Learn about supported countries',
			type: 'modal',
		},
		privacy: {
			type: 'link',
			href: 'https://example.com',
		},
		terms: {
			type: 'link',
			href: 'https://example.com',
		},
	};

	const onItemClick = itemId => {
		const optionSettings = itemDetails[itemId];

		if (optionSettings.type === 'modal') {
			dispatch(
				appSlice.actions.addModal({
					isHeaderWithColorBgAndIcon: true,
					title: optionSettings.title,
					subtitle: optionSettings.description,
					headerBackgroundColor: '#0455A3',
					headerIcon: optionSettings.icon,
					tag: 'CardDetailsInfo',
					headClass: 'CardDetailsInfo',
					isOpen: true,
					height: '70%',
					outsideParams: { itemId },
				})
			);
		} else {
			window.open(optionSettings.href, '_blank', 'noopener,noreferrer');
		}
	};

	const renderItem = (item, index, array) => {
		return (
			<ListItem
				key={item.id}
				className='CardTermsBlock-info__item'
				title={item.title}
				description={item.description && <span className='CardTermsBlock__item-description'>{item.description}</span>}
				icon={
					item.icon && (
						<div className='CardTermsBlock__icon-container'>
							<Icon  type={item.icon} width={20} height={20} />
						</div>
					)
				}
				bottomSeparator={index !== array.length - 1}
				rightTitle={<Icon className='CardTermsBlock-item-arrow' type={Icons.ARROW_CHEVRON} />}
				onSelect={() => onItemClick(item.id)}
			/>
		);
	};

	const infoItems = ITEMS.filter(i => i.block === 'info');
	const termsItems = ITEMS.filter(i => i.block === 'terms');

	return (
		<div className='CardTermsBlock'>
			<div className='CardTermsBlock-header'>
				<img src={CardImage} alt='card image' />
			</div>
			<div className='CardTermsBlock-info FormBlock'>{infoItems.map(renderItem)}</div>

			<div className='CardTermsBlock-terms FormBlock'>{termsItems.map(renderItem)}</div>
		</div>
	);
};

export default CardTermsBlock;
